module.exports = __webpack_public_path__ + "img/img33.2706aa75.svg";